let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("35VU5")).then(() => parcelRequire('6EPYm'));